import styled from 'styled-components';

import {
  greenSp,
  blackSphera,
  grayLightSphera,
  grayDarkSphera,
  whiteSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const LoginContainer = styled.section`
  display: flex;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const LoginInfo = styled.div`
  width: 50%;
  padding: 10% 0 5% 5%;

  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > h2 {
      color: ${blackSphera};
      line-height: 50px;
      margin-bottom: 5%;
      font-size: 3.5vw;
      > span {
        color: ${greenSp};
        font-size: 4vw;
        line-height: 50px;
        margin-right: 2%;
      }
    }
  }
  > p {
    color: ${blackSphera};
    font-size: 1.6vw;
    width: 85%;
    margin-bottom: 5%;
  }

  > ul {
    margin-left: 5%;

    > li {
      font-size: 1.6vw;
      color: ${blackSphera};
      margin-bottom: 1%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    width: 45%;
    > div {
      width: 100%;
      display: flex;
      flex-direction: row;
      > span {
        font-size: 4vw;
        margin-right: 2%;
        font-weight: bold;
      }
      > p {
        font-size: 4vw;
        font-weight: bold;
      }
    }

    > ul {
      margin: 5%;
      > li {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;

    > div {
      width: 100%;
      display: flex;
      flex-direction: row;
      > h2 {
        width: 100%;
        color: ${blackSphera};
        line-height: 50px;
        margin-bottom: 5%;
        font-weight: bold;
        font-size: 5vw;
        > span {
          color: ${greenSp};
          font-size: 5vw;
          line-height: 50px;
          margin-right: 2%;
        }
      }
    }
    > p {
      font-size: 4.5vw;
      width: 95%;
    }

    > ul {
      /* margin-left: 2%; */

      > li {
        font-size: 3.5vw;
      }
    }
  }
`;

export const LoginForm = styled.div`
  width: 50%;
  background-image: url('https://finsphera-webapp-resources.s3.amazonaws.com/ImageLoginForm.png');
  padding: 10% 0 0 0;

  > div {
    display: flex;
    flex-direction: column;
    width: 70%;
    margin: auto;
    padding: 5%;
    border-radius: 5px;
    background-color: ${whiteSphera};

    p {
      margin-bottom: 1rem;
    }

    > h3 {
      color: ${blackSphera};
      font-size: 1.6vw;
      font-weight: normal;
      text-align: center;
      margin-bottom: 5%;
    }

    > input:nth-child(3),
    > input:nth-child(4) {
      font-size: 1.2vw;
      margin-bottom: 2.5%;
      padding: 1% 0 1% 2.5%;
      border: none;
      border-bottom: 1px solid ${blackSphera};
      background-color: transparent;
      outline: none;

      &::placeholder {
        color: ${grayLightSphera};
      }
    }

    > button:nth-child(5) {
      font-size: 1.2vw;
      font-weight: bold;
      color: ${greenSp};
      text-decoration: none;
    }

    > button:nth-child(6) {
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.2vw;
      width: 60%;
      padding: 2% 0;
      margin: 10% auto 5% auto;
      border: none;
      border-radius: 5px;
      background-color: ${blackSphera};
      cursor: pointer;
    }
    > div {
      display: flex;
      justify-content: space-evenly;
      > p {
        text-align: center;
        font-size: 1.2vw;
        color: ${grayDarkSphera};
      }
      > button {
        font-size: 1.2vw;
        color: ${greenSp};
        text-decoration: none;
        text-align: center;
        margin-bottom: 5%;
        font-weight: bold;
        background-color: transparent;
        cursor: pointer;
        border: none;
      }
    }
    > button {
      font-size: 1.2vw;
      color: ${grayDarkSphera};
      font-weight: bold;
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > h3 {
      }

      > input:nth-child(3) {
        &::placeholder {
        }
      }

      > a:nth-child(3) {
      }

      > button:nth-child(5) {
        line-height: 40px;
        height: 40px;
      }

      > p:nth-child(5) {
      }

      > a:nth-child(6) {
      }

      > button:nth-child(8) {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-top: 3%;
    > div {
      width: 80%;
      margin: 5% 10%;
      > h3 {
        font-size: 4.2vw;
      }
      > input:nth-child(3),
      input:nth-child(4) {
        font-size: 4.2vw;
        &::placeholder {
        }
      }
      > a:nth-child(4) {
        font-size: 4.2vw;
      }

      > button:nth-child(5) {
        font-size: 4.2vw;
        width: 70%;
        align-self: center;
      }
      > div {
        > p {
          font-size: 4.2vw;
        }
        > button {
          font-size: 4.2vw;
        }
      }
      > button:nth-child(6) {
        font-size: 4.2vw;
      }

      button {
        font-size: 4.2vw;
      }
    }
  }
`;
